/* BrickSmart — Conversions API bridge (ported from the MBS Nutra funnel).
   Fires every event twice: once through the browser pixel, once server-side via a
   Cloudflare Worker. Both carry the same event_id, so Meta de-duplicates them and
   counts each action once — but the event still lands if the browser copy is blocked.
   BM_CAPI_URL is "" by default → server-side path is silently skipped. */
(function(){
  var ENDPOINT = (window.BM_CAPI_URL || "");   // set in config.js

  function uuid(){
    return "e-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2,10);
  }
  function cookie(name){
    var m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? m.pop() : undefined;
  }
  function fbc(){
    var c = cookie("_fbc");
    if(c) return c;
    var m = location.search.match(/[?&]fbclid=([^&]+)/);
    return m ? "fb.1." + Date.now() + "." + m[1] : undefined;
  }

  function toServer(eventName, eventId, customData){
    if(!ENDPOINT) return;
    var payload = {
      event_name: eventName,
      event_id: eventId,
      event_source_url: location.href,
      user_agent: navigator.userAgent,
      fbp: cookie("_fbp"),
      fbc: fbc(),
      custom_data: customData || {}
    };
    try{
      /* text/plain keeps this a CORS "simple request" — no preflight round-trip.
         The Worker parses the body as JSON regardless of the stated type. */
      var blob = new Blob([JSON.stringify(payload)], { type: "text/plain;charset=UTF-8" });
      if(navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob)) return;
    }catch(_e){}
    try{
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: "cors",
        credentials: "omit"
      }).catch(function(){});
    }catch(_e){}
  }

  /* Public: fire one event down both paths */
  window.BMTrack = function(eventName, customData){
    var id = uuid();
    try{ if(typeof fbq === "function") fbq("track", eventName, customData||{}, { eventID: id }); }catch(_e){}
    toServer(eventName, id, customData);
    return id;
  };

  /* PageView already fired in <head> with window.BM_PV_ID — mirror it server-side */
  if(window.BM_PV_ID) toServer("PageView", window.BM_PV_ID, {});
})();

/*bm-tail-patched*/
